import styled from '@emotion/styled'

export const PageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;

  @media (max-width: 1060px) {
    flex-direction: column;
    align-items: center;
  }
`

export const CardWrapper = styled.div`
  flex: 1;
  min-width: 580px;
  height: 100%;
  padding: 48px;

  @media (max-width: 1060px) {
    width: 100%;
    min-width: unset;
    max-width: calc(440px + 48px + 48px);
    min-height: 160px;
    max-height: 240px;
    padding: 0 48px;
    margin-top: 48px;
  }
`

export const FormWrapper = styled.div`
  flex: 1;
  height: 100%;
  padding: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 1060px) {
    width: 100%;
  }
`

export const Form = styled.form`
  width: 100%;
  max-width: 440px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const LinksWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
`

export const Link = styled.a`
  text-decoration: none;
  color: inherit;
`
